import { Unit } from '@interfaces/Material'
import { LP_UNIT_TYPE } from '@utils/constants/learningPath'

export const determinLCSZero = (unitId: string, units: Unit[]) => {
  const unit = (units || []).find(({ Id }) => Number(unitId) === Number(Id))
  return unit?.Order === 1 && unit?.UnitType === LP_UNIT_TYPE.COACHING
}
